module.exports = __webpack_public_path__ + "img/iconLeave.457272d2.png";